export default Object.freeze({
    WAIT_FOR_PROVIDER: 'Wait for provider to propose time slots',
    PROVIDER_SEND_SLOTS: 'Propose time slots',
    PROVIDER_SLOTS_SUBMITTED: 'Your time slots have been submitted',
    WAIT_FOR_REFERRER_SELECTION: 'Wait for referrer to select a time slot',
    SELECT_TIME_SLOT: 'Select a time slot',
    SELECT_NOW_URGENT: 'Select time slot now - deadline approaching',
    WAIT_FOR_CONFIRMATION: 'Waiting for provider confirmation',
    WAIT_FOR_PATIENT_VISIT: 'Waiting for patient visit',
    APPOINTMENT_SCHEDULED: 'Appointment scheduled',
    EXPIRED_NO_PROPOSALS: 'Expired - no proposals received',
    EXPIRED_NO_SELECTION: 'Expired - no selection made',
    CLOSED: 'Referral closed',
    UPLOAD_RECORDS: 'Please provide additional records',
})
